 /* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
// styles
import injectSheet from "react-jss";
import styles from './adplacement_styles.js';

const AdPlacement = injectSheet(styles)(props => {
  return (
    <div className={`${props.classes.adplacement} adplacement`} style={{
        width: '100%',
        minWidth: '150px',
        height: '125px',
      }}
    >
      <span style={{color: '#FFF', fontWeight: 700, fontSize: '32px' }}>AD SPACE</span>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdPlacement;